import React from "react";
import { Form } from "react-bootstrap";

const generateTimeOptions = () => {
	const times = [];
	for (let hour = 9; hour <= 23; hour++) {
		for (let minutes of [0, 15, 30, 45]) {
			const h = hour.toString().padStart(2, "0");
			const m = minutes.toString().padStart(2, "0");
			times.push(`${h}:${m}`);
		}
	}
	times.push("00:00");
	return times;
};

const TimeSelect = ({ name, value, onChange, label, required = true, inline = false }) => {
	const timeOptions = generateTimeOptions();

	const select = (
		<Form.Select name={name} value={value} onChange={onChange} className="bg-dark text-light" required={required}>
			<option value="">-- Select --</option>
			{timeOptions.map((time) => (
				<option key={time} value={time}>
					{time}
				</option>
			))}
		</Form.Select>
	);

	if (inline) return select;

	return (
		<Form.Group>
			{label && (
				<Form.Label>
					<i className="bi bi-clock me-2" />
					{label}
				</Form.Label>
			)}
			{select}
		</Form.Group>
	);
};

export default TimeSelect;
